import React from 'react';
import { useTenantUsage } from '../../api/usage';
import { Feedback, useAccessControl } from '@plerionhq/design-system';
import { Route, Routes, useMatch } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

export const DisplayUsageBlock = () => {
  const { t } = useTranslation('containerInterface');
  // Tenant:Read has no resource dimension, so holding it at all means the
  // caller can read tenant usage; a scoped role cannot, and these banners are
  // about org and tenant billing limits it can do nothing about.
  const { can } = useAccessControl();
  const { data, isLoading } = useTenantUsage(can({ action: 'Tenant:Read' }));
  const isOnAdminPage = useMatch('/admin/*');
  const isOnProfilePage = useMatch('/profile/*');
  if (isLoading || !data) {
    return <></>;
  }

  if (data.shouldBlockOrgUsage) {
    return (
      <Feedback
        title={t('usageBlocked')}
        variant="error"
        dismissible
        wrapperClassName="!border-0 !rounded-none px-6"
      >
        {t('yourOrganizationHasSurpassedTheAuthorizedUsage')}
      </Feedback>
    );
  }

  const showTenantUsageExceed = !isOnAdminPage && !isOnProfilePage;
  if (data.shouldBlockTenantUsage && showTenantUsageExceed) {
    return (
      <Routes>
        <Route
          path="*"
          element={
            <Feedback
              title={t('tenantUsageBlocked')}
              variant="error"
              dismissible
              wrapperClassName="!border-0 !rounded-none px-6"
            >
              {t('yourTenantUsageHasExceededTheAuthorized')}
            </Feedback>
          }
        />
      </Routes>
    );
  }

  return <></>;
};
